module.exports = __webpack_public_path__ + "static/img/TWO-TONE PU products discription_deskstop.deae32dc.jpg";